import { render } from "./WhySection.vue?vue&type=template&id=4bf511e4&scoped=true"
const script = {}

import "./WhySection.vue?vue&type=style&index=0&id=4bf511e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf511e4"]])

export default __exports__